
import CryptoJS from 'crypto-js';
import Utility from '../../services/utility.service';
import Loader from './../../../shared/components/loader'
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Util from '../../../shared/util/util';

export default {
    name: 'InscanShortShipment',
    components: {
        CustomExpandableTable,
        Util,
        Utility,
        Loader,
    },
    data: function () {
        return {
            AwbNo:"",
            isLoading:false,
            tableData:[],
            selectedMPS:[],
            comment:"",
            MpsCount:"",
            showtable:false,
            isAllSelected:'',
            currentHub:'',
            disabledflag:false,
        }
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.currentHub = userdetail.hubID[0];
        this.userName = userdetail.email;
    },
    methods: {
      setname(id, name){
        return name+id;
      },
      select(e){
        if(this.isAllSelected){
          this.isAllSelected=0
        }
      },
      isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      selectAll() {
        if (this.isAllSelected) {
          this.tableData.forEach(item => {
              if (this.selectedMPS.some(el => el.mps == item.mps)) {
                return
              } else  {
                this.selectedMPS.push(item)
              }
          })
        }else{
          this.selectedMPS=this.selectedMPS.filter(item=>{
            if(this.tableData.some(el=>el.mps==item.mps)){
              return false
            }else{
              return true
            }
          })
        }
      },
        reset() {
          this.AwbNo = "";
          this.comment ="";
          this.showtable = false;
          this.tableData =[];
          this.selectedMPS = []
          this.isAllSelected = ''
          this.disabledflag=false
          this.$validator.reset();
        },
        async search(){      
            try{
              this.$validator.validateAll("inscanmarkshortform").then( async (result) => {
                if(result){
                  this.tableData = []
                  this.isLoading=true;
                  let inputPayload = {
                    awb:this.AwbNo
                  };
                  let result = await Utility.GetShortMpsDetails(inputPayload);
                    if(result.data.code==200){
                    this.tableData = result.data.data;
                    this.isLoading=false;
                    this.showtable = true;
                    this.disabledflag=true
                  }
                  else {
                    this.isLoading=false;
                    this.$alert(result.data.message,"","error")
                  }
                }
              }).catch((err) => {
                console.error(err);
                return false;
              });
            }
            catch(err){
              this.$alert(err,"","error");
            }
          },
          async updateInscanShortShipment() {
            try {
              console.log("this.selectedMPS",this.selectedMPS)
              let inputPayload ={}
              this.isLoading = true
              if(this.selectedMPS.length == 0){
                this.$alert("Please Select MPS for Inscan Short Shipment","","error");
              }
              if(this.comment == '' || this.comment==""){
                this.$alert("Please Enter Comments","","error");
              }else{
                this.selectedMPS.map((el)=> {
                  return {
                  mps: el.MPS,
                  finaldestinationid: this.currentHub
                  }
                })
                  inputPayload = {
                    "mpsarr" :this.selectedMPS,
                    "comments": this.comment,
                    "lastmodifiedby": this.userName,
                    "awb":this.AwbNo
                  }
                  this.isLoading = true
                  let result = await Utility.UpdateShorttMpsDetails(inputPayload);
                  if(result.data.code == 200){
                    this.$alert("Inscan Short Shipment Successfully","","success");
                    this.showtable = false;
                    this.reset()
                    this.isLoading = false
                  }else{
                    this.$alert(result.data.message,"","error");
                    this.isLoading = false
                  }
              }
            this.isLoading = false
            } catch (err) {
              console.log(err);
            }
          },
          onSubmit: function(event) {
            this.$validator.validateAll().then((result) => {
              if(result){
                this.updateInscanShortShipment(event);
              }
            }).catch(() => {
              console.log('errors exist', this.errors)
            });
          },
    }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/inscanshortshipment/inscanshortshipment.component.js